const forms = {
  onRequest: "Κατόπιν αίτησης", // translated
  person: "πρόσωπο", // translated
  travelDate: "Ημερομηνία ταξιδιού", // translated
  travelDates: "Ημερομηνίες ταξιδιού", // translated
  cancel: "Ματαίωση", // translated
  getPrice: "Λήψη τιμής", // translated
};

export default forms;
